// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1YYiQ","footer":"ReportModalFilter_footer__2vyA3"};